import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { Columns, Column } from '@components/Columns';
import { themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import Carousel from 'nuka-carousel';

export const StyledText = styled(Text)`
  max-width: 90%;
  margin: auto;
  ${themeMediaQuery('below_sm')} {
    max-width: 96%;
    ${themeVariant('hed40')};
  }
  ${themeMediaQuery('sm')} {
    max-width: 60%;
  }
  ${themeMediaQuery('md')} {
    max-width: 35%;
  }
`;

export const StyledItemWrapper = styled(Flex)`
  cursor: pointer;

  ${themeMediaQuery('below_sm')} {
    cursor: default;
  }
`;

export const StyledItemColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(10)};
  }
`;

export const StyledGroupColumn = styled(Columns)`
  justify-content: space-around;

  ${themeMediaQuery('sm')} {
    max-width: 55rem;
  }
  ${themeMediaQuery('md')} {
    max-width: 90rem;
  }
`;

export const StyledImageColumns = styled(StyledGroupColumn)`
  position: relative;

  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledImageColumn = styled(Column)<{ left: number }>`
  position: absolute;
  left: ${({ left }) => left}%;
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
`;

export const StyledCircleFlex = styled(Flex)`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  place-items: center;
  justify-content: center;
  background: rgba(197, 169, 154, 0.3);
`;

export const StyledTitleText = styled(Text)`
  ${themeMediaQuery('sm')} {
    width: 150px;
  }
  ${themeMediaQuery('md')} {
    width: max-content;
  }
`;

export const StyledContentText = styled(Text)`
  font-family: AkkuratLLSub-RegularSubset, sans-serif;
  ${themeMediaQuery('sm')} {
    width: 190px;
  }
  ${themeMediaQuery('md')} {
    width: 250px;
  }
`;

export const StyledCarousel = styled(Carousel)`
  @keyframes fadeOut {
    0% {
      overflow: 1;
    }
    100% {
      opacity: 0;
    }
  }

  .slider-slide {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  .slider-slide:not(.slide-visible) {
    animation-name: fadeOut;
  }
`;

export const DisplayOnMobile = styled(Box)`
  ${themeMediaQuery('sm')} {
    display: none;
  }
`;

export const DisplayAboveMobile = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
